import './profile-grid.scss';

class ProfileGrid {

    constructor(element, options) {

        const settings = {
            initAttr: 'data-profilegrid', 
            wrapperAttr: 'wrapper', 
            itemAttr: 'item', 
            itemsAttr: 'items', 
            desktop: window.innerWidth >= window.OPTIONS.breakpoints.l, 
            resizeTimeout: 150
        };

        this.settings = Object.assign({}, settings, options);

        this.$profileGrid = element;

        this.initialize();
    }

    initialize() {

        if(this.settings.desktop === true) {
            this.setLayout('desktop');
        }

        document.addEventListener('sizeMobile', () => {
            this.setLayout('mobile');
        });

        document.addEventListener('sizeTablet', () => {
            this.setLayout('mobile');
        });

        document.addEventListener('sizeDesktop', () => {
            this.setLayout('desktop');
        });
    }

    setLayout(flag) {

        const $gridItems = this.$profileGrid.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.itemAttr + '"]');
        const $gridItemsContainer = this.$profileGrid.querySelector('[' + this.settings.initAttr + '="' + this.settings.itemsAttr + '"]');
        const $gridWrapper = this.$profileGrid.querySelector('[' + this.settings.initAttr + '="' + this.settings.wrapperAttr + '"]');

        if(flag === 'desktop') {

            for(let i = 0; i < $gridItems.length; i++) {
                $gridWrapper.appendChild($gridItems[i]);
            }
            $gridWrapper.appendChild($gridItemsContainer);

        } else {

            for(let i = 0; i < $gridItems.length; i++) {
                $gridItemsContainer.appendChild($gridItems[i]);
            }            
        }
    }
}

export { ProfileGrid };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-profilegrid="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new ProfileGrid($root);
            $rootAPI.initialize();
        });
    }
});
